export default __webpack_public_path__ + "static/media/rolex3.a5fbf272.png";